export const TERMINAL_PROPERTY_STATUSES = new Set([
  'handed_over',
  'completed',
  'rented',
  'terminated',
  'closed',
  'archived',
  'deleted',
  'removed',
  'inactive'
]);

function normalizeStatus(value) {
  return String(value || '').trim().toLowerCase();
}

export function isTerminalProperty(property = {}) {
  const handoverStatus = normalizeStatus(property?.management?.handoverStatus || property?.handoverStatus);
  const status = normalizeStatus(property?.status);
  return TERMINAL_PROPERTY_STATUSES.has(handoverStatus) || TERMINAL_PROPERTY_STATUSES.has(status);
}

export function isActiveProperty(property = {}) {
  return !isTerminalProperty(property);
}

export function isRentedProperty(property = {}) {
  if (property.isRented === true || property.rented === true) return true;
  if (property.isReserved === true) return true;
  const status = normalizeStatus(property.status);
  if (status === 'rented' || status === 'occupied' || status === 'unavailable') return true;
  // Backward compat: older rented properties only have isActive=false + rentedContractId
  if (property.isActive === false && (property.rentedContractId || property.rentedBy)) return true;
  return false;
}

export function isTenantVisibleProperty(property = {}) {
  if (!property || typeof property !== 'object') return false;

  // Never show terminal/rented lifecycle properties in tenant discovery.
  if (isTerminalProperty(property)) return false;

  // Never show properties explicitly marked as rented.
  if (isRentedProperty(property)) return false;

  // Never show soft-deleted properties.
  if (property.deleted === true || property.isDeleted === true || property.deletedAt) return false;

  const externalSource = String(property.externalSource || '').trim().toLowerCase();
  const status = normalizeStatus(property.status);

  // Never show draft/unpublished properties.
  if (status === 'draft' || status === 'unpublished') return false;

  // CRM listings are only public after explicit publish from review queue.
  if (externalSource === 'crm_integration') {
    return property.crmPublished === true || status === 'published' || status === 'live';
  }

  // Any non-CRM source (including empty/legacy values) remains tenant-visible.
  return true;
}
